import { TextField } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Theme from '../ui/Theme';

const useStyles = makeStyles({
  textfield: {
    backgroundColor: Theme.palette.secondary.main,
    width: (props) => props.width || '321px',
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
    marginBottom: '12px',
  },
});

const PopupTextField = (props) => {
  const classes = useStyles(props);

  return (
    <TextField
      id={props.id}
      name={props.name}
      style={{ height: props.height }}
      required
      autoFocus
      autoComplete="off"
      autoSave="off"
      onChange={props.handleChange}
      placeholder={props.placeholder}
      multiline
      InputProps={{
        disableUnderline: true,
        classes: {
          input: classes.textfield,
        },
      }}
      value={props.value}
      rows={props.rows}
      disabled={props.disabled || false}
    />
  );
};

export default PopupTextField;
